var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"design-system"},[_c('el-container',[_c('el-aside',{staticClass:"left-section"},[_c('DesignSystemSidebar')],1),_c('el-container',{staticClass:"main-section"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }